import { IColours } from '../colours';

export const nameFont = (colours: IColours) => ({
  font: 'poppins',
  fontSize: { xs: 50, sm: 120 },
  fontWeight: 400,
  color: colours.primary,
});
